import { render, staticRenderFns } from "./customerOrderSupplement.vue?vue&type=template&id=627464d4&scoped=true&"
import script from "./customerOrderSupplement.vue?vue&type=script&lang=js&"
export * from "./customerOrderSupplement.vue?vue&type=script&lang=js&"
import style0 from "./customerOrderSupplement.vue?vue&type=style&index=0&id=627464d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627464d4",
  null
  
)

export default component.exports